import api from './api';

/**
 * Servicio para gestionar usuarios
 */
export const usuariosService = {
  /**
   * Obtener todos los usuarios
   * @param {number} empresaId - ID de la empresa para filtrar (opcional)
   */
  getAll: async (empresaId = null) => {
    const params = {};
    if (empresaId) params.empresaId = empresaId;
    const response = await api.get('/usuarios', { params });
    return response;
  },

  /**
   * Obtener un usuario por ID
   * @param {number} id - ID del usuario
   */
  getById: async (id) => {
    const response = await api.get(`/usuarios/${id}`);
    return response;
  },

  /**
   * Crear un nuevo usuario
   * @param {object} usuario - Datos del usuario
   */
  create: async (usuario) => {
    const response = await api.post('/usuarios', usuario);
    return response;
  },

  /**
   * Actualizar un usuario
   * @param {number} id - ID del usuario
   * @param {object} usuario - Datos actualizados del usuario
   */
  update: async (id, usuario) => {
    const response = await api.put(`/usuarios/${id}`, usuario);
    return response;
  },

  /**
   * Desactivar un usuario (baja lógica)
   * @param {number} id - ID del usuario
   */
  delete: async (id) => {
    const response = await api.delete(`/usuarios/${id}`);
    return response;
  },

  /**
   * Asignar roles a un usuario
   * @param {number} id - ID del usuario
   * @param {array} rolIDs - Lista de IDs de roles
   */
  asignarRoles: async (id, rolIDs) => {
    const response = await api.post(`/usuarios/${id}/roles`, {
      RolIDs: rolIDs,
    });
    return response;
  },

  /**
   * Asignar sucursales a un usuario
   * @param {number} id - ID del usuario
   * @param {array} sucursalIDs - Lista de IDs de sucursales
   */
  asignarSucursales: async (id, sucursalIDs) => {
    const response = await api.post(`/usuarios/${id}/sucursales`, {
      SucursalIDs: sucursalIDs,
    });
    return response;
  },
};

